import {Card} from 'platform/components';
import {Box, getValueByDevice, Stack, useDevice, VStack} from 'platform/foundation';

import {range} from 'ramda';

import {SkeletonLoadingBox} from '@dms/shared';

const COLUMN_SPACING = 4;
const COLUMN_FLEX = 1;
const DIVIDER_BORDER = '1px solid';
const DIVIDER_COLOR = 'general.separator' as const;
const FIRST_COLUMN_INDEX = 0;

/** The board always shows at least three tiles, and four whenever margin is visible. */
const COLUMN_COUNT = 4;

const LABEL_WIDTH = 26;
const VALUE_WIDTH = 30;
const FOOTER_WIDTH = 22;

/*
  Line heights are the real ones, so the panel does not resize when the figures arrive:
  the label is Text xSmall (16px), the value Heading 1 (32px), and the footer is as tall as
  the Trend chip that sits in it (24px) rather than its text.
*/
const LABEL_LINE = 4;
const VALUE_LINE = 8;
const FOOTER_LINE = 6;
const COLUMN_LINE_SPACING = 2;

export function SalesLeagueKpiPanelSkeleton() {
  const device = useDevice();
  const isRow = getValueByDevice(device, false, false, true);

  return (
    <Card>
      <Stack direction={isRow ? 'row' : 'column'} spacing={COLUMN_SPACING} align="stretch">
        {range(0, COLUMN_COUNT).map((column) => {
          const isDivided = column !== FIRST_COLUMN_INDEX;

          return (
            <Box
              key={column}
              flex={isRow ? COLUMN_FLEX : undefined}
              paddingLeft={isDivided && isRow ? COLUMN_SPACING : 0}
              paddingTop={isDivided && !isRow ? COLUMN_SPACING : 0}
              borderLeft={isDivided && isRow ? DIVIDER_BORDER : undefined}
              borderTop={isDivided && !isRow ? DIVIDER_BORDER : undefined}
              borderColor={DIVIDER_COLOR}
            >
              <VStack spacing={COLUMN_LINE_SPACING}>
                <SkeletonLoadingBox isLoading width={LABEL_WIDTH} height={LABEL_LINE} />
                <SkeletonLoadingBox isLoading width={VALUE_WIDTH} height={VALUE_LINE} />
                <SkeletonLoadingBox isLoading width={FOOTER_WIDTH} height={FOOTER_LINE} />
              </VStack>
            </Box>
          );
        })}
      </Stack>
    </Card>
  );
}
